/*
 * @Author: your name
 * @Date: 2020-04-15 10:48:41
 * @LastEditTime: 2020-07-27 13:32:03
 * @LastEditors: Lina
 * @Description: In User Settings Edit
 * @FilePath: /FE-DSTemplate/src/services/apiConfig.js
 */
export function isProduction() {
  return (typeof window !== 'undefined') ? window.location.host === 'static.ccrgt.com' : false;
}

export const userAuthorUrl = isProduction()
  ? 'https://apicloud.ccrgt.com/crgt/user-center/userActivity'
  : 'https://t-apicloud.ccrgt.com/crgt-test/user-center/userActivity';

export const activityUrl = isProduction()
  ? 'https://fe-bp-dynamic-activity.ccrgt.com'
  // ? 'http://127.0.0.1:7001'
  : 'https://t-fe-bp-dynamic-activity.ccrgt.com';

export const blockVideo = isProduction()
  ? 'https://fe-bp-block-video-draw.ccrgt.com'
  // : 'http://127.0.0.1:7001'
  : 'https://t-fe-bp-block-video-draw.ccrgt.com'


export const movieDailyCoupon = isProduction()
  ? 'https://fe-bp-period.ccrgt.com/activity/movieDaily'
  : 'https://t-fe-bp-period.ccrgt.com/activity/movieDaily'

const selectApiHost = (config) => {
  return isProduction() ? config.isProd : config.isDev
}

export const apiConfig = {
  wxDiscountCard: {
    isProd: 'https://apicloud.ccrgt.com/crgt/coupon-activity',
    isDev: 'https://t-apicloud.ccrgt.com/crgt-test/coupon-activity'
  },
  hotelApi: {
    isProd:'https://apicloud.ccrgt.com/crgt/hotel-searchcore',
    isDev: 'https://t-apicloud.ccrgt.com/crgt-test/hotel-searchcore'
  },
  selectApiHost: selectApiHost
}


